interface NoImageProps {
    minHeight?: number;
}

const NoImage = ({ minHeight }: NoImageProps): JSX.Element => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                minHeight: minHeight ? `${minHeight}px` : "300px",
                height: !minHeight ? "100%" : undefined,
                backgroundColor: "#e0e0e0",
            }}
        >
            <div>Snapshot not available</div>
        </div>
    );
};

export default NoImage;
